import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
const SvgSpeechBubbleAnchor = (props, ref) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 8, viewBox: "0 0 16 8", fill: "none", ref: ref, ...props, children: _jsx("path", { d: "M9.41421 6.58579C8.63316 7.36684 7.36683 7.36684 6.58579 6.58579L0 0L16 1.01598e-06L9.41421 6.58579Z", fill: "currentColor" }) }));
const ForwardRef = forwardRef(SvgSpeechBubbleAnchor);
export default ForwardRef;
